$('[data-cart-input]').on('change', function(e) {
    axios.get('/ajax/cart.php?id=' + $(this).data('id') + '&amount=' + $(this).val()).then((response) => {
        location.reload();
    });
});

$('[data-cart-button]').on('click', function(e) {
    e.preventDefault();
    var that = this;

    axios.get('/ajax/cart.php?id=' + $(this).data('id') + '&extra=' + $(this).data('extra')).then((response) => {
        if (response.data.result == 'ADDED') {
            $(that).addClass('added');
        } else if (response.data.result == 'DELETED') {
            $(that).removeClass('added');;
        }

        $('.cart-total-count').text(response.data.total);
        $(that).find('span').text(response.data.text)
    });
});


// WEBPACK FOOTER //
// ./js/modules/_cart.js